import { render } from "./AddFarmerModal3.vue?vue&type=template&id=0f2bf9be&scoped=true"
import script from "./AddFarmerModal3.vue?vue&type=script&lang=js"
export * from "./AddFarmerModal3.vue?vue&type=script&lang=js"

import "./AddFarmerModal3.vue?vue&type=style&index=0&id=0f2bf9be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2bf9be"]])

export default __exports__